import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CreateOrderMethod} from "../../../../oms/angular/enums/create-order-method.enum";
import * as angular from "angular";
import * as _ from "lodash";
import {TagType} from "../../../../tags/angular/types/tag.type";
import {TagModel} from "../../../../tags/angular/models/tag.model";

require('./bringoz-tags.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-tags',
  templateUrl: './bringoz-tags.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozTagsComponent implements OnInit, OnChanges {

  @Input() tags: any;
  @Input() tagType: TagType = TagType.Info;
  @Input() isShowTagDescriptions: boolean = false;
  @Input() maxTags: any;
  @Input() color: string;
  @Input() backgroundColor: string;


  public tagsMap: any;
  public viewTags: any;
  public extraTags: any;
  public createOrderMethodTypes: typeof CreateOrderMethod = CreateOrderMethod;
  private tagsToHide: any[];
  private tagsWithColor: any[]
  private siteSkills: any[];
  public tagsDescription: TagModel[];

  constructor(@Inject('splitService') private splitService, @Inject('tagsService') private tagsService) {

  }

  ngOnInit() {
    this.tagsToHide = this.splitService.getIsSite() ? (this.splitService.getTagsToHide() || []) : [];
    this.tagsWithColor = this.splitService.getIsSite() ? (this.splitService.getTagsWithColor() || []) : [];
    // A tag named like a site skill takes the skill's colour, as app-bringoz-tag did on its own
    this.siteSkills = this.splitService.getIsSite() ? (this.splitService.getSiteSkills() || []) : [];
    this.tagsMap = this.createOrderMethodTypes;
    this._initTags(this.tags);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tags && !changes.tags.isFirstChange() ||
      changes.maxTags && !changes.maxTags.isFirstChange()) {
      this._initTags(this.tags);
    }
  }

  getTagsDescription() {
    if (!this.tagsDescription && !!this.tags?.length && this.isShowTagDescriptions) {
      this.tagsService.getTagsByName(this.tags, this.tagType)
        .then((tags) => {
          this.tagsDescription = tags;
        })
    }
  }

  private _initTags(tags) {
    this.viewTags = [];
    this.extraTags = [];

    if (!tags?.length) {
      return;
    }

    const tagIdsToHIde = _.map(this.tagsToHide, 'id');
    const tagNamesToHIde = _.map(this.tagsToHide, 'name');
    const consoleTags = (tags || []).filter((t) => {
      return !!t.id ? !_.includes(tagIdsToHIde, t.id) : !_.includes(tagNamesToHIde, t);
    })

    const infoTagEntity = consoleTags.map((tag) => {
      const tagEntity = this.tagsWithColor.find((t) => t.name === tag);
      return {
        name: tag,
        color: tagEntity?.color || _.find(this.siteSkills, {name: tag})?.color,
      }
    })

    this.viewTags = this.maxTags ? infoTagEntity.filter((tag, index) => {
      return index < this.maxTags
    }) : infoTagEntity;


    if (consoleTags.length > this.maxTags) {
      const tagsCopy = angular.copy(consoleTags);
      this.extraTags = tagsCopy.slice(this.viewTags.length);
    }
  }


}
